/**
 * @description Enable pathways for logged in users
 */
export const showPathwaysUserBased = () => {
  return true;
};

/**
 * @description Returns whether the pathways section on the XDP should be shown
 */
export const showPathwaysXDP = (isCareerRolePathway: boolean) => {
  if (!isCareerRolePathway) {
    return false;
  }

  return true;
};

/**
 * @description Returns whether the pathways section on the Career Academy should be shown
 */
export const showPathwaysCareerAcademyPages = () => {
  return true;
};
